import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import Layout from './components/Layout';
import Dashboard from './pages/Dashboard';
import QueueManagement from './pages/QueueManagement';
import FormBuilder from './pages/FormBuilder';
import FormRenderer from './pages/FormRenderer';
import FormSubmissions from './pages/FormSubmissions';
import Login from './pages/Login';
import { AuthProvider, useAuth } from './contexts/AuthContext';

const theme = createTheme({
  palette: {
    mode: 'light',
    primary: {
      main: '#1976d2',
    },
    secondary: {
      main: '#dc004e',
    },
    background: {
      default: '#f5f5f5',
    },
  },
});

function AuthenticatedApp() {
  const { isAuthenticated, loading } = useAuth();

  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100vh' }}>
        <CircularProgress />
      </Box>
    );
  }

  if (!isAuthenticated) {
    return <Login />;
  }

  return (
    <Box sx={{ display: 'flex' }}>
      <Layout>
        <Routes>
          <Route path="/" element={<Navigate to="/dashboard" />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/tasks" element={<QueueManagement />} />
          <Route path="/forms" element={<FormBuilder />} />
          <Route path="/forms/render/:formTemplateId" element={<FormRenderer />} />
          <Route path="/submissions" element={<FormSubmissions />} />
          {/* Redirect old routes to new ones */}
          <Route path="/queue" element={<Navigate to="/tasks" replace />} />
        </Routes>
      </Layout>
    </Box>
  );
}

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Router>
        <AuthProvider>
          <AuthenticatedApp />
        </AuthProvider>
      </Router>
    </ThemeProvider>
  );
}

export default App;
